import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Form, { ButtonItem, ButtonOptions, Item, Label, RequiredRule } from 'devextreme-react/form';
import Request from '../../components/api/Request';
import * as AppActions from '../../actions/AppActions';
import { ToastType } from '../../constants/Constants';
import { showToast } from '../../utils/Utils';

const ParolaDegistir = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    newPassword: '',
    newPasswordConfirmation: ''
  });

  const onFieldDataChanged = (e) => {
    if (e.dataField) {
      setFormData((prev) => ({ ...prev, [e.dataField]: e.value }));
    }
  };

  const kaydet = (e) => {
    let eksikBilgi = false;
    e.validationGroup.validators.forEach((a) => {
      if (a.validate().status !== 'valid') {
        eksikBilgi = true;
      }
    });
    if (eksikBilgi) {
      showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
      return;
    }
    if (formData.newPassword !== formData.newPasswordConfirmation) {
      showToast('Yeni parola ve tekrarı eşleşmiyor', ToastType.ERROR, 500);
      return;
    }

    const payload = {
      newPassword: formData.newPassword,
      newPasswordConfirmation: formData.newPasswordConfirmation
    };
    const request = new Request('/kullanici/change-password', 'POST', payload);
    dispatch(AppActions.setLoading(true, 'Parola güncelleniyor..'));
    request.run().then((response) => {
      dispatch(AppActions.setLoading(false, ''));
      if (response && response.status === 200 && response.data) {
        showToast('Parolanız güncellendi', ToastType.SUCCESS, 1500);
        setFormData({ newPassword: '', newPasswordConfirmation: '' });
      }
    });
  };

  return (
    <React.Fragment>
      <h2 className={'content-block'}>Parola değiştir</h2>
      <div className={'content-block dx-card responsive-paddings'} style={{ maxWidth: 480 }}>
        <Form
          formData={formData}
          onFieldDataChanged={onFieldDataChanged}
          colCount={1}
          id="parolaDegistirForm"
          labelLocation={'left'}
          className="option"
        >
          <Item
            dataField={'newPassword'}
            editorType={'dxTextBox'}
            editorOptions={{ mode: 'password', showClearButton: true }}
          >
            <RequiredRule message="Yeni parola gerekli" />
            <Label text="Yeni parola" />
          </Item>
          <Item
            dataField={'newPasswordConfirmation'}
            editorType={'dxTextBox'}
            editorOptions={{ mode: 'password', showClearButton: true }}
          >
            <RequiredRule message="Yeni parola tekrarı gerekli" />
            <Label text="Yeni parola (tekrar)" />
          </Item>
          <ButtonItem>
            <ButtonOptions
              onClick={(ev) => kaydet(ev)}
              width={'100%'}
              type={'success'}
              useSubmitBehavior={true}
            >
              <span className="dx-button-text">Kaydet</span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </div>
    </React.Fragment>
  );
};

export default ParolaDegistir;
